import React, { useRef, useState } from "react";

function ContextMenuTrigger({ trigger, contextMenu }) {
  const [show, setIsShow] = useState(false);
  const triggerRef = useRef(null);

  function handleOpen() {
    setIsShow(true);
  }

  function handleClose() {
    setIsShow(false);
  }

  function getPosition() {
    if (triggerRef.current != null) {
      const rect = triggerRef.current.getBoundingClientRect();
      return {
        x: rect.x,
        y: rect.y + rect.height,
      };
    } else {
      return {
        x: 0,
        y: 0,
      };
    }
  }

  return (
    <>
      {React.cloneElement(trigger, {
        onClick: () => {
          handleOpen();
        },
        ref: triggerRef,
      })}
      {show &&
        contextMenu &&
        React.cloneElement(contextMenu, {
          // position: { x: triggerRef.current.clientX, y: trigger.current.clientY },
          position: getPosition(),
          onClose: function () {
            handleClose();
          },
        })}
    </>
  );
}

export default ContextMenuTrigger;
